<template>
    <div class="printContent" v-loading="ticketLoading">
        <div class="print-t clearfix" v-if="ticketReady">
            <div class="print-tle">我的准考证</div>
            <div class="print-tr">
                <!-- <span class="print-tr-question"><i class="el-icon-bell"></i> 反馈问题</span> -->
                <el-button type="danger" v-print="printConfig"><i class="el-icon-printer"></i> 打印准考证</el-button>
            </div>
        </div>
        <div class="printDom" id="printArea" v-if="ticketReady">
            <div class="print-bg"><img src="../assets/images/printTable-bg.png" /></div>
            <table class="printTable">
                <tr>
                    <td colspan="8" class="bg">
                        <div class="printTable-subtle">潞安化工集团 {{ currentYear }} 年招聘考试</div>
                        <div class="printTable-tle">准 考 证</div>
                    </td>
                </tr>
                <tr>
                    <td width="16%" colspan="2" rowspan="4" class="bg">
                        <div class="printTable-avatar">
                            <div class="printTable-avatar-p"><img :src="ticketData.photoUrl" /></div>
                        </div>
                    </td>
                    <td width="14%" colspan="2" class="bg">姓名</td>
                    <td width="36%" colspan="3" class="lw">{{ ticketData.userName }}</td>
                    <td :rowspan="notesRowSpan" class="lw printTable-notes" valign="top">
                        <div class="printTable-notes-title"><B>考生注意事项</B></div>
                        <ol class="printTable-ol">
                            <li>考前30分钟，凭准考证和身份证进入考场，对号入座，开考 30 分钟后不得入场。</li>
                            <li>严禁将手机和其他带有储存功能的电子产品带入考场，一经发现，按违纪处理。</li>
                            <li>服从监考人员管理，严格遵守考场规则、应试人员违纪违规处理规定，作弊必究。</li>
                            <li>答卷前，请认真填写考生姓名、准考证号等信息。</li>
                            <li>此准考证适用于笔试和面试。</li>
                        </ol>
                        <div class="printTable-company">潞安化工集团(人力资源部)制</div>
                        <div class="printTable-time">{{ printDateLabel }}</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="bg">身份证</td>
                    <td colspan="3" class="lw">{{ ticketData.idCard }}</td>
                </tr>
                <tr>
                    <td colspan="2" class="bg">准考证</td>
                    <td colspan="3" class="lw">{{ ticketData.ticketNumber }}</td>
                </tr>
                <tr>
                    <td colspan="2" class="bg">考场信息</td>
                    <td width="18%" colspan="2">
                        <div>考场编号</div>
                        <div><B style="font-size: 20px;">{{ ticketData.roomNumber }}</B> 室</div>
                    </td>
                    <td width="18%">
                        <div>座位号</div>
                        <div><B style="font-size: 20px;">{{ ticketData.seatNumber }}</B> 号</div>
                    </td>
                </tr>
                <tr>
                    <td width="13%" class="bg">考试专业</td>
                    <td width="53%" colspan="6" class="lw">{{ ticketData.positionName }}</td>
                </tr>
                <tr>
                    <td class="bg">考试地点</td>
                    <td colspan="6" class="lw">{{ ticketData.examLocation }}</td>
                </tr>
                <tr>
                    <td width="22%" colspan="3" class="bg">考试科目</td>
                    <td width="22%" colspan="2" class="bg">考试日期</td>
                    <td width="22%" colspan="2" class="bg">考试时间</td>
                </tr>
                <tr v-for="(item,index) in examScheduleList" :key="index" class="printTable-exam-row">
                    <td colspan="3" class="printTable-exam-subject">{{ item.examSubject }}</td>
                    <td colspan="2">{{ item.examDate }}</td>
                    <td colspan="2">{{ item.examTime }}-{{ item.examTimeEnd }}</td>
                </tr>
            </table>
        </div>
        <div class="printTips" v-if="ticketReady">温馨提示：请使用A4纸张纵向打印，保证字迹清晰。</div>
        <div v-if="!ticketLoading && !ticketReady" class="print-empty">
            <i class="el-icon-warning-outline"></i>
            <p>{{ ticketError || '暂无准考证信息' }}</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
export default {
    name: 'PagePrint',
    data() {
        return {
            ticketLoading: true,
            ticketReady: false,
            ticketError: '',
            ticketData: {},
            printConfig:{
                id:'printArea', //被打印部分的id
                popTitle:''
            },
        }
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
        printDateLabel() {
            const d = new Date();
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day} 打印`;
        },
        examScheduleList() {
            const list = this.ticketData && this.ticketData.examSchedulechedulesList;
            return Array.isArray(list) ? list : [];
        },
        /** 考生注意事项列：从「姓名」行起至表格最后一行（含所有考试科目） */
        notesRowSpan() {
            return 7 + this.examScheduleList.length;
        },
    },
    mounted() {
        document.title = '潞安招聘-打印准考证';
        this.getTicket();
    },
    methods: {
        getTicket: function () {
            if (!Cookies.get('reqToKen')) {
                this.ticketLoading = false;
                this.ticketError = '请先登录';
                return;
            }
            this.ticketLoading = true;
            axios.get('/zhaopinapi/exam-admission-tickets/currently', {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.ticketData = _d.data;
                    this.ticketReady = true;
                    this.ticketError = '';
                } else {
                    this.ticketReady = false;
                    this.ticketError = _d.message || '暂无准考证信息';
                }
            }).catch((error) => {
                console.log(error);
                this.ticketReady = false;
                const msg = error.response && error.response.data && error.response.data.message;
                this.ticketError = msg || '暂无准考证信息';
            }).finally(() => {
                this.ticketLoading = false;
            });
        },
    }
}
</script>

<style scoped>
    .printContent{width: 210mm; margin: 0 auto; padding: 40px 0;}
    .print-t{padding-bottom: 24px;}
    .print-tle{color: #323232; font-size: 28px; font-weight: 400; line-height: 34px; float: left;}
    .print-tr{float: right;}
    .print-tr-question{padding-right: 15px;}
    .printDom{padding: 32px; background: #fff; position: relative; overflow: hidden;}
    .print-bg{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 72%;
        max-width: 420px;
        transform: translate(-50%, -50%);
        z-index: 0;
        pointer-events: none;
        opacity: 0.18;
    }
    .print-bg img{width: 100%; height: auto; display: block;}
    .printTable{
        border: 2px solid #101828;
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        position: relative;
        z-index: 1;
        background: transparent;
    }
    .printTable td{
        border: 1px solid #101828;
        padding: 12px;
        text-align: center;
        background: rgba(255, 255, 255, 0.88);
    }
    .printTable td.lw{text-align: left;}
    .printTable td.bg{background: rgba(249, 250, 251, 0.92);}
    .printTable-subtle{padding-top: 16px; line-height: 28px; padding-bottom: 12px; font-size: 24px; font-weight: 500;}
    .printTable-tle{padding-bottom: 20px; line-height: 40px; font-size: 36px; font-weight: 500; letter-spacing: 0.5em;}
    .printTable-avatar{border: 1px solid #D1D5DC; background: #E5E7EB; height: 110px;}
    .printTable-avatar-p{height: 110px;}
    .printTable-avatar-p img{width: 100%; height: 110px; object-fit: cover; border: none;}
    .printTable-ol{margin: 0; padding-left: 15px;}
    .printTable-ol li{padding-bottom: 10px; line-height: 24px;}
    .printTable-notes{
        vertical-align: top;
        word-break: break-word;
        border-left: 1px solid #101828;
        border-right: 1px solid #101828;
    }
    .printTable-notes-title{
        text-align: center;
        font-weight: bold;
        padding-bottom: 8px;
        background: #F9FAFB;
        margin: -12px -12px 8px;
        padding: 8px 12px;
        border-bottom: 1px solid #101828;
    }
    .printTable-company{padding-top: 24px; text-align: center; font-weight: bold; line-height: 26px; font-size: 12px;}
    .printTable-time{color: #99A1AF; text-align: right; padding-top: 12px; font-size: 12px; padding-right: 8px;}
    .printTable-exam-subject{word-break: break-word; text-align: left;}
    .printTable-exam-row td{font-size: 12px; padding: 8px 10px;}
    .printTips{color: #99A1AF; font-size: 12px; line-height: 30px; padding-top: 16px; text-align: center;}
    .print-empty{
        min-height: 320px;
        padding: 80px 24px;
        text-align: center;
        color: #6A7282;
        background: #fff;
        border-radius: 8px;
    }
    .print-empty i{font-size: 48px; color: #E6A23C; margin-bottom: 16px;}
    .print-empty p{margin: 0; font-size: 16px; line-height: 28px;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>

<!-- 打印时 v-print 会克隆 #printArea，此处不用 scoped 以保证 @media print 生效 -->
<style>
@media print {
    @page {
        size: A4 portrait;
        margin: 8mm;
    }
    body {
        margin: 0;
        padding: 0;
    }
    #printArea.printDom {
        width: 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        box-sizing: border-box;
    }
    #printArea .print-bg {
        display: block !important;
        opacity: 0.14 !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
    #printArea .printTable {
        width: 100% !important;
        table-layout: fixed;
        font-size: 11px;
        background: transparent !important;
    }
    #printArea .printTable td {
        background: rgba(255, 255, 255, 0.9) !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
    #printArea .printTable td.bg {
        background: rgba(249, 250, 251, 0.92) !important;
    }
    #printArea .printTable tr {
        page-break-inside: avoid;
    }
    #printArea .printTable td {
        padding: 5px 6px !important;
        line-height: 1.35;
    }
    #printArea .printTable-subtle {
        font-size: 18px;
        padding-top: 8px;
        padding-bottom: 6px;
    }
    #printArea .printTable-tle {
        font-size: 28px;
        padding-bottom: 10px;
        line-height: 32px;
    }
    #printArea .printTable-ol li {
        padding-bottom: 4px;
        line-height: 1.35;
        font-size: 10px;
    }
    #printArea .printTable-company {
        padding-top: 16px !important;
        font-size: 11px;
        line-height: 1.4;
    }
    #printArea .printTable-time {
        padding-top: 8px;
        font-size: 10px;
    }
    #printArea .printTable-exam-row td {
        font-size: 10px;
        padding: 4px 5px !important;
    }
    #printArea .printTable-notes {
        width: 30%;
        border-right: 1px solid #101828 !important;
        border-bottom: 1px solid #101828 !important;
    }
    #printArea .printTable-exam-row:last-child td {
        border-bottom: 1px solid #101828 !important;
    }
    #printArea .printTable-notes-title {
        margin: -5px -6px 6px;
        padding: 6px;
    }
}
</style>
